import {MutationTree} from 'vuex';
import {Community, CommunityInitState} from '@/store/community/community.types';

export const CommunityMutations: MutationTree<CommunityInitState> = {
  ['mutationGetCommunity'](state: CommunityInitState, payload: Community[]) {
    state.community = payload;
  },
  ['mutationTotalCommunity'](state: CommunityInitState, payload: number) {
    state.totalCommunity = payload;
  }
};
